import React, { useState, useEffect, useCallback, useRef } from 'react';
import './generate-doc.scss';
import { HtmlEditor, Toolbar, Item, } from 'devextreme-react/html-editor';
import { Button } from 'devextreme-react/button';
import {getDocumentById, updateDocument} from '../../api/api'
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import TextBox from 'devextreme-react/text-box';

const sizeValues = [ "8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt" ];
const fontValues = [ "Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana" ];
const headerValues = [ false, 1, 2, 3, 4, 5 ];

export default function GenerateDocEdit() {
  const { user, refreshSession } = useAuth();
  let { document_id } = useParams();
  const navigate = useNavigate();

  const editorRef = useRef(null);

  const [htmlData, setHtmlData] = useState(null);
  const [docData, setDocData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [documentName, setDocumentName] = useState("New Document");

  const onNameChanged = useCallback((e) => {
    setDocumentName(e.value);
    console.log(e.value);
  }, [setDocumentName])


  const onValueChanged = (e) => {
    setHtmlData(e.value)
  }

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      console.log(error);
    }
  }, [refreshSession]);

  const onDocumentDataSuccess = useCallback((data) => {
    setHtmlData(data.html.replace("```html","").replace("```",""))
    if (data.document_name) {
      setDocumentName(data.document_name)
    }
    setDocData(data)
    setLoading(false);
  }, [])

  const onDocumentDataSaveSuccess = useCallback((data) => {
    onDocumentDataSuccess(data);
    navigate("/generate/print/"+document_id);
  }, [document_id, navigate, onDocumentDataSuccess])

  const onPreview = useCallback((data) => {
    docData.html = htmlData
    docData.document_name = documentName
    updateDocument(user, docData, onDocumentDataSaveSuccess, onError);
    setLoading(true);
  }, [documentName, docData, htmlData, user, onDocumentDataSaveSuccess, onError])

  useEffect(() => {
    if (user.signInUserSession) {
      getDocumentById(user, document_id, onDocumentDataSuccess, onError)
    }
  }, [user, document_id, onDocumentDataSuccess, onError]);

  return (
    <React.Fragment>
      {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <div className="d-flex flex-column">

        <div className="d-flex flex-row justify-content-between align-items-end">
          <div className="pe-3" style={{minWidth:"60%"}}>
            <TextBox
              value={documentName}
              label="Template Name"
              labelMode="floating"
              onValueChanged={onNameChanged}
              width="100%"
            />
          </div>
          <Button
              text="Cancel"
              icon="fas fa-chevron-left"
              onClick={() => {navigate("/templates")}}
          />
          <Button
              text="Preview"
              icon="fas fa-print"
              onClick={onPreview}
          />
        </div>
        <hr/>
        <div className="" style={{height:"74vh"}}>
        <HtmlEditor
          ref={editorRef}
          onValueChanged={onValueChanged}
          value={htmlData}
          height="100%"
        >
          <Toolbar multiline={true}>
            <Item name="undo" />
            <Item name="redo" />
            <Item name="separator" />
            <Item name="size" acceptedValues={sizeValues} />
            <Item name="font" acceptedValues={fontValues} />
            <Item name="separator" />
            <Item name="bold" />
            <Item name="italic" />
            <Item name="strike" />
            <Item name="underline" />
            <Item name="separator" />
            <Item name="alignLeft" />
            <Item name="alignCenter" />
            <Item name="alignRight" />
            <Item name="alignJustify" />
            <Item name="separator" />
            <Item name="orderedList" />
            <Item name="bulletList" />
            <Item name="separator" />
            <Item name="header" acceptedValues={headerValues} />
            <Item name="separator" />
            <Item name="color" />
            <Item name="background" />
            <Item name="separator" />
            <Item name="link" />
            <Item name="image" />
            <Item name="separator" />
            <Item name="clear" />
            <Item name="codeBlock" />
            <Item name="blockquote" />
            <Item name="separator" />
            <Item name="insertTable" />
            <Item name="insertHeaderRow" />
            <Item name="insertRowAbove" />
            <Item name="insertRowBelow" />
            <Item name="separator" />
            <Item name="insertColumnLeft" />
            <Item name="insertColumnRight" />
            <Item name="separator" />
            <Item name="deleteColumn" />
            <Item name="deleteRow" />
            <Item name="deleteTable" />
            <Item name="separator" />
            <Item name="cellProperties" />
            <Item name="tableProperties" />
          </Toolbar>
        </HtmlEditor>



      </div>
      </div>}

    </React.Fragment>
)}
